<template>
  <v-card class="sw-filter-panel-popup tickets-action-menu__card" elevation="0">
    <header class="sw-filter-panel-popup__header">
      <h2 class="sw-filter-panel-popup__title">{{ title }}</h2>
      <v-btn
        icon
        variant="text"
        size="x-small"
        class="sw-filter-panel-popup__close"
        aria-label="Close filter panel"
        @click="$emit('close')"
      >
        <v-icon size="18">mdi-close</v-icon>
      </v-btn>
    </header>

    <div class="sw-filter-panel-popup__body">
      <slot />
    </div>
  </v-card>
</template>

<script>
export default {
  name: "SwFilterDrawer",
  props: {
    title: { type: String, default: "Filter panel" },
  },
  emits: ["close"],
};
</script>
